module.exports = __webpack_public_path__ + "static/media/competitions.526a8a03.svg";